import { useEffect } from 'react';

import { useStores } from '../../stores/useStores';

export function useJackpotStart() {
  const { categoriesStore, rewardsStore, coinTypeStore } = useStores();

  useEffect(() => {
    Object.values(categoriesStore.categoriesRegistry).forEach((category) => {
      category.subCategoryGames.forEach((game) => {
        const { moreDetails, masterCasinoProviderId } = game;

        if (
          'jackpotFeedGC' in Object(moreDetails) &&
          'jackpotFeedSC' in Object(moreDetails) &&
          !rewardsStore.providersJackpots[masterCasinoProviderId]
        ) {
          rewardsStore.setProviderJackpot(masterCasinoProviderId, {
            gcAmount: moreDetails.jackpotFeedGC,
            scAmount: moreDetails.jackpotFeedSC,
            jackpotType: moreDetails.jackpotType,
          });
        }
      });
    });

    rewardsStore.startJackpotCounter({ coinType: coinTypeStore.coinType });
  }, [
    categoriesStore.categoriesRegistry,
    categoriesStore.currentCategory,
    coinTypeStore.coinType,
    rewardsStore.providersJackpots,
    rewardsStore,
  ]);
}
